import React, { useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './MemberPhotoSlider.css';
import defaultUserImage from '../../assets/images/user/default.webp';

const MemberPhotoSlider = ({
  images = [],
  alt = 'Profile photo',
  className = '',
  imageClassName = '',
  nested = false,
}) => {
  const photos = images.filter(Boolean);

  const handleImageError = useCallback((e) => {
    e.target.src = defaultUserImage;
    e.target.onerror = null;
  }, []);

  // The slider usually sits inside a card-wide link, so a tap on a dot must not navigate.
  const keepPaginationTapsLocal = useCallback((e) => {
    if (e.target.closest('.swiper-pagination')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, []);

  if (photos.length <= 1) {
    return (
      <img
        src={photos[0] || defaultUserImage}
        alt={alt}
        loading="lazy"
        onError={handleImageError}
        className={imageClassName}
      />
    );
  }

  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    <div className={`member-photo-slider ${className}`.trim()} onClick={keepPaginationTapsLocal}>
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={1}
        spaceBetween={0}
        loop
        nested={nested}
      >
        {photos.map((src, index) => (
          <SwiperSlide key={src}>
            <img
              src={src}
              alt={`${alt} ${index + 1}`}
              loading="lazy"
              onError={handleImageError}
              className={imageClassName}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MemberPhotoSlider;
